<template>
    <div class="board">
        <div class="bar">
            <b-icon icon="card-checklist" class="icon"></b-icon>
            <span>รายการบันทึกการสอบถาม</span>
        </div>

        <div class="content">
            <div class="filter form mb-4">
                <prospect-filter @lookup="filterProspectList($event)"></prospect-filter>
            </div>

            <div class="mb-4 text-right">
                <button class="btn btn-main" @click="openProspectForm()">เพิ่มบันทึกรายการสอบถาม</button>
            </div>

            <perfect-scrollbar>
                <table>
                    <thead>
                        <tr>
                            <th class="action-column"></th>
                            <th>วันที่บันทึก</th>
                            <th>ข้อมูลลูกค้า</th>
                            <th>ข้อมูลรถ</th>
                            <th>ติดต่อเรื่อง</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in prospectList.filter((value, index) => $AppUtility.renderByPage(this.activePage, this.pageSize, index))" :key="index">
                            <td class="text-center text-nowrap">
                                <button class="icon" @click="deleteProspect(item)"><b-icon icon="trash"></b-icon></button>
                            </td>
                            <td>{{ item.date }}</td>
                            <td>
                                <span class="main">{{ item.customer }}</span>
                                <span><b-icon icon="telephone" class="icon"></b-icon> {{ item.tel }}</span>
                            </td>
                            <td>
                                <span class="main">{{ item.license }}</span>
                                <span><b-icon icon="minecart-loaded" class="icon"></b-icon> {{ item.car }}</span>
                            </td>
                            <td>{{ item.detail }}</td>
                        </tr>
                    </tbody>
                </table>
            </perfect-scrollbar>

            <loader-spinner :isDisplay="isLoading" class="mt-4 mb-4"></loader-spinner>

            <div class="no-data" v-if="prospectList.length === 0 && !isLoading">
                <b-icon icon="exclamation-diamond"></b-icon>
                <span>ไม่พบรายการสอบถาม</span>
            </div>

            <paging @page="changePage($event)" :activePage="activePage" :pageSize="pageSize" :contentLength="prospectList.length" class="mt-4"></paging>
        </div>

        <prospect-modal-form :isDisplay="isShowProspectForm" @hide="closeProspectForm($event)"></prospect-modal-form>
    </div>
</template>

<script>
import ProspectFilter from '@/components/prospect/Filter';
import ProspectModalForm from '@/components/prospect/ModalForm';
import OptionProspectTopic from '@/database/staticOption/ProspectTopic';
import OptionLicensePlateProvince from '@/database/staticOption/LicensePlateProvince';
import DBProspect from '@/database/Prospect';
import ModelKeywordFilter from '@/resources/models/KeywordFilter';

export default {
    components: {
        ProspectFilter,
        ProspectModalForm
    },
    data() {
        return {
            isShowProspectForm: false,
            prospectList: [],
            prospectFilter: ModelKeywordFilter.data(),
            isLoading: false,
            activePage: 1,
            pageSize: 20
        }
    },
    mounted() {
        this.loadProspectList();
    },
    methods: {
        openProspectForm() {
            this.isShowProspectForm = true;
        },
        closeProspectForm(isReload) {
            this.isShowProspectForm = false;

            if (isReload) {
                this.loadProspectList();
            }
        },
        filterProspectList(value) {
            this.prospectFilter = value;
            this.loadProspectList();
        },
        filterResult(result) {
            if (this.prospectFilter.keyword) {
                result = result.filter(x => x.customer?.toLowerCase().indexOf(this.prospectFilter.keyword.toLowerCase()) > -1 
                                        || x.tel?.toLowerCase().indexOf(this.prospectFilter.keyword.toLowerCase()) > -1
                                        || x.licensePlate?.toLowerCase().indexOf(this.prospectFilter.keyword.toLowerCase()) > -1
                                        || x.carBrand?.toLowerCase().indexOf(this.prospectFilter.keyword.toLowerCase()) > -1
                                        || x.carModel?.toLowerCase().indexOf(this.prospectFilter.keyword.toLowerCase()) > -1
                                        || x.carYearSerie?.toLowerCase().indexOf(this.prospectFilter.keyword.toLowerCase()) > -1
                                        || x.topic?.toLowerCase().indexOf(this.prospectFilter.keyword.toLowerCase()) > -1
                                        || x.detail?.toLowerCase().indexOf(this.prospectFilter.keyword.toLowerCase()) > -1)
            }

            return result;
        },
        async loadProspectList() {
            this.isLoading = true;
            this.prospectList = [];
            const result = await DBProspect.get();

            if (result.content && result.content.length > 0) {
                // Filter Result
                result.content = this.filterResult(result.content);

                // Map and Place into the Object
                this.prospectList = this.mapViewData(result.content);
            }

            this.isLoading = false;
        },
        mapViewData(content) {
            const data = [];

             content.forEach((item) => {
                data.push({
                    date: this.$AppUtility.displayTimeFormat(item.date),
                    customer: item.customer,
                    tel: item.tel,
                    license: [ item.licensePlate, '(' + OptionLicensePlateProvince.service.getValueByKey(item.licensePlateProvince) + ')'].join(' '),
                    car: [ item.carBrand, item.carModel, item.carYearSerie ].filter(Boolean).join(' '),
                    detail: OptionProspectTopic.service.getValueByKey(item.topic) + (item.detail ? ': ' + item.detail : '')
                });
             });

            return data;
        },
        deleteProspect(item) {
            this.$swal({
                title: 'ลบข้อมูลสอบถาม?',
                text: 'โปรดยืนยันว่าต้องการลบรายการบันทึกข้อมูลสอบถาม',
                icon: 'question',
                showCancelButton: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const loader = this.$AppUtility.renderLoadBackdrop();

                    await DBProspect.delete(item);

                    this.loadProspectList();
                    loader.hide();
                }
            });
        },
        changePage(value) {
            this.activePage = value;
        }
    }
}
</script>